(function ($) {
    $.noConflict();
       document.addEventListener('userway:init_completed', function (event) {
           window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'open') {
            setTimeout(() => {
              let formElement = $(".klaviyo-form[data-testid='klaviyo-form-" + e.detail.formId + "']");
              let overallElement = formElement.parent().parent().parent().parent().parent().parent();
              let closeButton = overallElement.find(".klaviyo-close-form");
              $(closeButton).on("click", function() {
                overallElement.css("display", "none");
              });
          }, 1000);
        }
    });
    });
    $(document).ready(function () {

        // Back to top Scroll Button
        var btn = $('#toTheTop');

        $(window).scroll(function() {
            if ($(window).scrollTop() > 300) {
            btn.addClass('show');
            } else {
            btn.removeClass('show');
            }
        });

        btn.on('click', function(e) {
            e.preventDefault();
            $('html, body').animate({ scrollTop:0 }, '300');
        });

        // Open new window outgoing URLs
        $('a').attr('target', function() {
          if(this.host == location.host) return '_self'
          else return '_blank'
        });
 
        // Sub-Navigation
        $('#mobile-sub-navigation-button').click(function (){
            $('.subNavigationMobile').toggle();
        });

        // Sticky Social Icons
        $('.sticky-social-icons-button').click(function (){
            $('.sticky-social-icons').toggleClass('open');
        });

        // Collection Sidebar Show More
        /*$(".tag-list").filter(function () {
            return $(this).find('li').length > 10
             }).append('<li class="showMore">Show More</li>');
         
         $('.tag-list li:nth-child(10)').nextAll('li').hide();
         
         $('.showMore').click(function(){
           $(this).siblings('.tag-list li:nth-child(10)').nextAll('li').slideToggle('slow');
           $(this).text(function(i, text){
                return text === "Show More" ? "Show Less" : "Show More";
            });
         });*/

        // Pause/Play Video Feature
        $('.videoPause').click(function() {
            $('video').trigger('pause');
        });
        $('.videoPlay').click(function() {
            $('video').trigger('play');
        });

        // Zoom Banner
        $(".premium-banner img, .premium-banner-content, .parallax-banner, .collection-hero").addClass("loaded");

        // Cart Drawer Overlay
        $('.js-drawer-open-cart').click(function (){
            $('#CartDrawerOverlay').show();
        });

        $('.js-drawer-close').click(function (){
            $('#CartDrawerOverlay').hide();
        });

        // Fast Ship Pop Uo
        $('.fast-ship-drop-button').click(function (){
            $('.fast-ship-popup-click').toggle();
        });

        // Sizing Chart Popup
        $('.size-chart-button').click(function (){
            $('.size-chart-overlay').fadeIn(500);
            $('.size-chart-popup').fadeIn(500);
            $('body').addClass('locked');
        });
        $('.size-chart-close-button, .size-chart-overlay').click(function (){
            $('.size-chart-overlay').fadeOut(300);
            $('.size-chart-popup').fadeOut(300);
            $('body').removeClass('locked');
        });

    });
})(jQuery);